import { useContent } from '@/lib/content';
import { resolveMediaSrc } from '@/lib/api';
import { Reveal, SectionHeading } from '@/components/Reveal';

const PILLARS = [
  { title: 'Our Mission', text: 'To take the weight of planning off your shoulders, so your only job on the big day is to live it fully.' },
  { title: 'Our Vision', text: 'To be the most trusted name in celebrations across Telangana — one unforgettable event at a time.' },
  { title: 'Our Approach', text: 'Listen first. Design with heart. Execute with discipline. Every event gets our whole team and our whole attention.' },
];

export const About = () => {
  const { settings } = useContent();
  return (
  <section id="about" data-testid="about-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading chapter="01" label="Who We Are" title={<>The people behind <span className="italic text-champagne">your</span> celebration</>} />

      <div className="mt-16 grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        <Reveal className="relative">
          <div className="overflow-hidden">
            <img
              src={resolveMediaSrc(settings.founderImage)}
              alt="Abhishek Jindal — Anchor AJ, Founder of Events by AJ, hosting a premium event"
              loading="lazy"
              className="w-full aspect-[4/5] object-cover object-top hover:scale-105 transition-transform duration-700 ease-out"
            />
          </div>
          <div className="absolute -bottom-6 -right-2 sm:-right-6 bg-champagne text-ink px-6 py-5 max-w-[240px]">
            <p className="font-serif text-2xl leading-tight">Abhishek Jindal</p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.3em] font-semibold">Founder & Anchor AJ</p>
          </div>
        </Reveal>

        <div className="lg:pt-6">
          <Reveal delay={0.1}>
            <p className="text-base md:text-lg text-white/80 font-light leading-relaxed tracking-wide">
              Events by AJ began with a simple belief — a celebration should feel like a gift, not a project.
              Founded in Hyderabad by <span className="text-cream">Abhishek Jindal</span>, known on stage as
              <span className="italic text-champagne"> Anchor AJ</span>, the company has grown into one of the
              region&rsquo;s most trusted names in end-to-end event management.
            </p>
            <p className="mt-6 text-base md:text-lg text-white/80 font-light leading-relaxed tracking-wide">
              Abhishek sees events from both sides of the stage — as a planner who obsesses over every detail,
              and as a professional anchor who has hosted hundreds of live celebrations. That rare combination
              means your event is not just organised well; it <span className="text-cream">flows</span> beautifully,
              moment after moment.
            </p>
            <p className="mt-6 text-base md:text-lg text-white/80 font-light leading-relaxed tracking-wide">
              From weddings and birthdays to devotional evenings and corporate galas, our team handles everything —
              planning, decor, photography, entertainment, catering, sound, logistics — so you can simply be present
              for the moments that matter.
            </p>
          </Reveal>

          <div className="mt-12 space-y-0 border-t border-white/10">
            {PILLARS.map((p, i) => (
              <Reveal key={p.title} delay={0.1 + i * 0.08} className="py-6 border-b border-white/10 grid sm:grid-cols-[160px_1fr] gap-2 sm:gap-6">
                <p className="caption-label pt-1">{p.title}</p>
                <p className="text-white/70 font-light leading-relaxed">{p.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};
